import { useNavigate } from 'react-router'
import { OfficePage } from '../pages/OfficePage.tsx'
import './painel-do-escritorio.css'

/**
 * Escritório em painel suspenso (SPEC-20261104-1438, pedido do Cristian):
 * abre pelo botão da barra como as notificações e os membros — janela
 * encostada à direita com ~65% da largura, só visualização (tabuleiro e
 * seletor de andar), fecha ao clicar fora. O botão de expandir leva à tela
 * cheia `/office`, com todos os recursos.
 */
export function PainelDoEscritorio({ aberto, onFechar }: { aberto: boolean; onFechar: () => void }) {
  const navigate = useNavigate()
  if (!aberto) return null
  return (
    <aside className="epanel" aria-label="Escritório virtual">
      <header className="epanel__head">
        <span className="epanel__title">Escritório virtual</span>
        <span className="epanel__grow" />
        {/* o Expandir mora no canto do mapa (SPEC-20261104-1610); aqui fica só o Fechar */}
        <button type="button" className="epanel__btn" aria-label="Fechar" title="Fechar" onClick={onFechar}>
          <i className="fas fa-times" aria-hidden />
        </button>
      </header>
      <div className="epanel__body">
        <OfficePage
          modoPainel
          aoExpandir={() => {
            onFechar()
            navigate('/office')
          }}
        />
      </div>
    </aside>
  )
}
